import { Injectable } from '@angular/core';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';

import { IInvoiceReb, IProjectInvoicesRebResponse } from './manage-invoice-reb.interfaces';

@Injectable()
export class ManageInvoiceRebService {
  private _API_BASE_URL: string = environment['API_URL'];

  public getByProject(projectCode: string): Observable<IProjectInvoicesRebResponse> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'invoiceReb/project/' + projectCode)
      .pipe(map(response => response || []));
  }

  public get(): Observable<IProjectInvoicesRebResponse> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'invoiceReb')
      .pipe(map(response => response || []));
  }

  public getById(invoiceId: string): Observable<IInvoiceReb> {
    return this.authHttp.get<any>(this._API_BASE_URL + 'invoiceReb/' + invoiceId)
      .pipe(map(response => response || {}));
  }

  public create(payload: IInvoiceReb): Observable<IInvoiceReb> {
    return this.authHttp.post<any>(this._API_BASE_URL + 'invoiceReb/', payload)
      .pipe(map(response => response || {}));
  }

  public update(invoiceId: number, payload: IInvoiceReb): Observable<IInvoiceReb> {
    return this.authHttp.put<any>(this._API_BASE_URL + 'invoiceReb/' + invoiceId, payload)
      .pipe(map(response => response || []));
  }

  public destroy(invoiceId: number): Observable<IInvoiceReb> {
    return this.authHttp.delete<any>(this._API_BASE_URL + 'invoiceReb/' + invoiceId)
      .pipe(map(response => response || []));
  }
  constructor(private authHttp: HttpClient) { }
}
